import { DecimalPipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ 
  name: 'formattedDecimal',
  standalone: false
})
export class FormattedDecimalPipe implements PipeTransform {

    constructor(
        private decimalPipe: DecimalPipe
    ) {}

    transform(rawValue: number, format: string = '1.0-0'): string {
        const text = this.decimalPipe.transform(rawValue, format);
        return text?.replace(/[\s]{1}/g, " ") ?? '0';
    }
}